import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EditIcon from '@guildeducationinc/recess/icons/EditIcon';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { isEveryoneCriteria } from '@src/utilities/criteriaHelper';
import { ContentType, DataTable, Messages, TrackableButton, useContents, useLocale, } from 'pe-core-frontend';
import { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
export const Contents = () => {
    const clientId = useClientIdParam() || 0;
    const { type = 'webpage' } = useParams();
    const isAttestation = type === 'attestations';
    const navigate = useNavigate();
    const { t, formatToLocalDate } = useLocale();
    const contentType = type === 'webpage' ? ContentType.WEBPAGE : ContentType.OTHER;
    const { contents, loading } = useContents({
        clientId,
        contentType,
        extraData: isAttestation ? { type: 'attestations' } : undefined,
        includeInactive: true,
    });
    const [messages, setMessages] = useState([]);
    const handleSelected = (content) => {
        navigate(`/admin/clients/${clientId}/comms/${type}/${content.id}`);
    };
    const columns = useMemo(() => {
        const cols = [
            {
                field: 'name',
                headerName: t('Name'),
                flex: 0.25,
                sortable: false,
            },
        ];
        if (isAttestation) {
            cols.push({
                field: 'extraData',
                headerName: t('Type'),
                flex: 0.25,
                sortable: false,
                valueGetter: ({ row }) => t(`content.attestationType.${row.extraData?.attestationType}`),
            });
        }
        else {
            cols.push({
                field: 'code',
                headerName: t('Code'),
                flex: 0.25,
                sortable: false,
            });
        }
        cols.push({
            field: 'isActive',
            headerName: t('Active?'),
            width: 100,
            renderCell: ({ value }) => (value ? t('Yes') : t('No')),
        }, {
            field: 'startsOn',
            headerName: t('Starts on'),
            width: 120,
            renderCell: ({ value }) => value ? formatToLocalDate(value, { dateStyle: 'medium' }) : '-',
        }, {
            field: 'expiresOn',
            headerName: t('Expires on'),
            width: 120,
            renderCell: ({ value }) => value ? formatToLocalDate(value, { dateStyle: 'medium' }) : '-',
        }, {
            field: 'criteria',
            headerName: t('Applies To'),
            width: 200,
            renderCell: ({ value }) => {
                if (isEveryoneCriteria(value))
                    return t('Everyone');
                return t('Specific Groups');
            },
        }, {
            field: 'action',
            headerName: t('Action'),
            renderCell: ({ row }) => (_jsx("div", { children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Edit', tag: `content_${row.id}`, label: t('Edit'), appearance: 'minimal', icon: _jsx(EditIcon, { size: 20 }), onClick: () => handleSelected(row), className: 'margin--right_8' }) })),
            width: 100,
            sortable: false,
        });
        return cols;
    }, []);
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Content'), navLinks: [
                    {
                        title: t('Webpage'),
                        path: `/admin/clients/${clientId}/comms/webpage`,
                        selected: type === 'webpage',
                    },
                    {
                        title: t('Attestations'),
                        path: `/admin/clients/${clientId}/comms/attestations`,
                        selected: type === 'attestations',
                    },
                ], actions: _jsx(TrackableButton, { btnType: 'mui', enText: 'Add Content', tag: 'header', variant: 'contained', className: 'button button--primary margin--bottom_16', onClick: () => navigate(`/admin/clients/${clientId}/comms/${type}/new`), children: t('Add Content') }) }), _jsxs("div", { children: [_jsx(Messages, { className: 'mb-3', messages: messages, onClose: () => setMessages([]) }), _jsx("div", { className: 'flex gap-3' }), _jsx(DataTable, { rowHeight: 54, disableColumnMenu: true, disableRowSelectionOnClick: true, rows: contents, hideFooter: true, loading: loading, columns: columns })] })] }));
};
